import script from "./PackagePlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PackagePlanCard.vue?vue&type=script&setup=true&lang=js"

import "./PackagePlanCard.vue?vue&type=style&index=0&id=6c43ab0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c43ab0e"]])

export default __exports__